import { createWebHistory, createRouter } from "vue-router";
import store from '../store';

import AuthRoutes from './auth';
import UserRoutes from './user'
import SettingRoutes from './setting'

import Home from "../views/Home";
import Orbital from "../views/Orbital";
import Cyclorama from "../views/Cyclorama";
import Video from "../views/Video";
import VRTour from "../views/VRTour";
import Gallery from "../views/Gallery";
import Contact from "../views/Contact.vue";

import ErrorNotFound from "../views/errors/notFound"


import ProjectRoutes from './project'
import StatusRoutes from './status'
import BuildingRoutes from './building'
import FloorRoutes from './floor'
import UnitRoutes from './unit'
import GalleryRoutes from './gallery'
import ContactRoutes from './contact'
import CategoryRoutes from './category'
import CorporationRoutes from './corporation'
import DomainRoutes from './domain'
import VideoRoutes from './video'
import ToursRoutes from './tour'
import Unit360View from '../views/units/360View.vue'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/:locale(fr|en)?/orbital/:project?/:building?/:floor?/:unit?',
            name: 'orbital-show',
            component: Orbital,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?/cyclorama',
            name: 'cyclorama',
            component: Cyclorama,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?/video',
            name: 'video',
            component: Video,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?/contact',
            name: 'contact',
            component: Contact,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?/gallery',
            name: 'front-gallery',
            component: Gallery,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?/visites-virtuelles/:tour?',
            name: 'virtual-tour',
            component: VRTour,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/:locale(fr|en)?',
            name: 'home',
            component: Home,
            meta: {
                allowAnonymous: true
            }
        },
        {
            path: '/admin/',
            redirect: { name: 'corporations' }
        },
        {
            path: '/admin/404',
            name: '404',
            component: ErrorNotFound,
        },
        {
            path: '/iframe/unit/:id',
            name: 'unit-v360',
            component: Unit360View,
            meta: {
                allowAnonymous: true
            }
        },
        ...AuthRoutes,
        ...UserRoutes,

        ...ProjectRoutes,
        ...StatusRoutes,
        ...BuildingRoutes,
        ...FloorRoutes,
        ...UnitRoutes,
        ...GalleryRoutes,
        ...ContactRoutes,
        ...CategoryRoutes,
        ...SettingRoutes,
        ...CorporationRoutes,
        ...DomainRoutes,
        ...VideoRoutes,
        ...ToursRoutes
    ],
});

router.beforeEach((to, from, next) => {
    const authUser = store.getters['auth/auth_user'];

    // Front public locale handling: default to 'fr' if missing/invalid
    const routeLocale = to.params.locale;
    const allowed = store.state.config.langs || ['fr','en'];
    const targetLocale = allowed.includes(routeLocale) ? routeLocale : 'fr';
    if(store.state.config.locale !== targetLocale) {
        store.dispatch('config/setLocale', targetLocale);
    }

    document.querySelector("body").classList.remove('nav-is-toggled');

    if(document.querySelector(".subnav--vv")) {
        document.querySelector(".subnav--vv").classList.remove("active--color")
    }

    if(document.querySelector("ul.display--submenu--vv")) {
        document.querySelector("ul.display--submenu--vv").style.display = "none"
    }

    if(to.meta.allowAnonymous) {
        next();
    }else if(!authUser) {
        store.dispatch('auth/getAuthUser').then( () => {

            if(!store.getters['auth/auth_user']) {
                next({path: "/login"});
            }else {
                if(from) {
                    if(to.meta.authorize) {
                        if(to.meta.authorize.includes(Number(store.getters['auth/auth_user'].role))) {
                            next();
                        }else {
                            store.dispatch('toasts/add', {type: 'error', message: 'Unauthorized'}, {root: true});
                            next({path: '/admin'});
                        }
                    }else {
                        next();
                    }
                }else {
                    next({ path: '/admin'} );
                }
            }
        })
        .catch( error => console.warn(error))
        .finally( () => store.commit('auth/SET_AUTH_PENDING', false) )
    }else if( authUser ) {
        if(to.meta.authorize) {
            if(to.meta.authorize.includes(Number(store.getters['auth/auth_user'].role))) {
                next();
            }else {
                store.dispatch('toasts/add', {type: 'error', message: 'Unauthorized'}, {root: true});
                next({path: '/admin'});
            }
        }else {
            next();
        }
    }
})


export default router;
